import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearPane } from '../../../store/cameras/actions';
import { Routes } from '../../../types';
import { setInitialCameras, shrankVideoLayout } from '../../../store/layouts/actions';
import { IconComponent } from '../simpleComponents';
import { ApplicationState } from '../../../store';
import { RouterState } from 'connected-react-router';
import { CamerasState } from '../../../store/cameras/types';

interface Props {
  pane: number
}

const ClearPaneComponent: React.FC<Props> = ({pane}) => {
  const dispatch = useDispatch();
  const {currentCameras} = useSelector<ApplicationState, CamerasState>(state => state.cameras);
  const {location} = useSelector<ApplicationState, RouterState>(state => state.router);
  const path = location.pathname;

  const clearCameraPane = () => {
    dispatch(clearPane(pane));
    dispatch(shrankVideoLayout());
    if (path === Routes.live) {
      dispatch(setInitialCameras(currentCameras));
    }
  }

  return (<>
    {
      (path === Routes.live || path === Routes.browse) && <IconComponent handler={(e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        clearCameraPane();
      }}
         classValue={'clear__pane icon'}
         clickedClassValue={' active'}
         title="Clear pane"
      />
    }
  </>)
};

export default ClearPaneComponent;